"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMetadataFromGrpcWeb = exports.convertMetadataToGrpcWeb = void 0;
const grpc_web_1 = require("@improbable-eng/grpc-web");
const nice_grpc_common_1 = require("nice-grpc-common");
const js_base64_1 = require("js-base64");
function convertMetadataToGrpcWeb(metadata) {
    const grpcMetadata = new grpc_web_1.grpc.Metadata();
    for (const [key, values] of metadata) {
        for (const value of values) {
            grpcMetadata.append(key, typeof value === 'string' ? value : js_base64_1.Base64.fromUint8Array(value));
        }
    }
    return grpcMetadata;
}
exports.convertMetadataToGrpcWeb = convertMetadataToGrpcWeb;
function convertMetadataFromGrpcWeb(grpcMetadata) {
    const metadata = (0, nice_grpc_common_1.Metadata)();
    for (const [key, values] of Object.entries(grpcMetadata.headersMap)) {
        metadata.set(key, key.endsWith('-bin')
            ? values.map(value => js_base64_1.Base64.toUint8Array(value))
            : values);
    }
    return metadata;
}
exports.convertMetadataFromGrpcWeb = convertMetadataFromGrpcWeb;
//# sourceMappingURL=convertMetadata.js.map